/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Equipper, EquipperInterface } from "../Equipper";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "equipmentContract",
        type: "address",
      },
      {
        internalType: "address",
        name: "tournamentContractAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "assetsContract",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "equipment",
    outputs: [
      {
        internalType: "contract IGameEquipment",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "equippings",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "int256",
        name: "hitPoints",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "attack",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "defense",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "percentChanceOfUse",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "numberOfUsesPerGame",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "createdAt",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "gladiatorId",
        type: "uint256",
      },
    ],
    name: "gladiatorEquipment",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "int256",
            name: "hitPoints",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "attack",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "defense",
            type: "int256",
          },
          {
            internalType: "uint256",
            name: "percentChanceOfUse",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "numberOfUsesPerGame",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "createdAt",
            type: "bytes32",
          },
        ],
        internalType: "struct IGameEquipment.EquipmentMetadata[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Equipper__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    equipmentContract: string,
    tournamentContractAddress: string,
    assetsContract: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Equipper> {
    return super.deploy(
      equipmentContract,
      tournamentContractAddress,
      assetsContract,
      overrides || {}
    ) as Promise<Equipper>;
  }
  getDeployTransaction(
    equipmentContract: string,
    tournamentContractAddress: string,
    assetsContract: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      equipmentContract,
      tournamentContractAddress,
      assetsContract,
      overrides || {}
    );
  }
  attach(address: string): Equipper {
    return super.attach(address) as Equipper;
  }
  connect(signer: Signer): Equipper__factory {
    return super.connect(signer) as Equipper__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): EquipperInterface {
    return new utils.Interface(_abi) as EquipperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Equipper {
    return new Contract(address, _abi, signerOrProvider) as Equipper;
  }
}
